export function objectToArray(obj) {
  return obj ? Object.keys(obj).map(value => ({value,label:obj[value]})) : []
}
